module.exports = __webpack_public_path__ + "static/media/Well.7257220d.svg";